// extracted by mini-css-extract-plugin
export default {"sidebarMap":"SidebarMap-module__sidebarMap___T0iQb"};